export default "__VITE_ASSET__C0hxoM_S__"